module.exports = __webpack_public_path__ + "static/media/soccer.c6370ffc.webp";